import { Col, EntityInfo, Grid, Row } from "@codat/orchard-ui";
import * as React from "react";

import { CompanySummary } from "../../../Models";
import styles from "../../CompaniesTable/CompaniesTable.module.css";
import IntegrationNugget from "../../IntegrationNugget/IntegrationNugget";

interface Props {
  value: CompanySummary;
}
const IntegrationCell: React.FC<Pick<Props, "value">> = ({ value }) => {
  return (
    <Grid>
      <Row collapseMargin className={styles.connectorRow}>
        <Col size={1}>
          <IntegrationNugget int={value.connectorIntegration} />
        </Col>
        <Col className={styles.connectorCol}>
          <EntityInfo
            className={styles.entityInfo}
            title={value.connectorId}
            subtitle={`${value.connectorCompanies} ${
              value.connectorCompanies > 1 ? "companies" : "company"
            }`}
          />
        </Col>
      </Row>
    </Grid>
  );
};

export default IntegrationCell;
